import React from 'react';
import './HealModal.css';
import rcoinIcon from '../assets/icons/rcoin.webp';
import ranchIcon from '../assets/icons/ranch.webp';
import closeIcon from '../assets/icons/closeIcons.webp';

function HealModal({ isOpen, onClose, healCost, onConfirm, isProcessing }) {
  if (!isOpen) return null;

  const handleConfirm = () => {
    if (onConfirm && !isProcessing) {
      onConfirm();
    }
  };

  return (
    <div className="heal-modal-overlay" onClick={onClose}>
      <div className="heal-modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="heal-modal-header">
          <h3>Heal Asset</h3>
          <button className="heal-modal-close" onClick={onClose}>
            <img src={closeIcon} alt="Close" />
          </button>
        </div>
        
        <div className="heal-modal-body">
          <p>This will restore your asset's decay to full health (336 hours).</p>
          
          {healCost && (
            <div className="heal-cost-display">
              <div className="heal-cost-label">Cost:</div>
              <div className="heal-cost-value">
                {
                  healCost.token === 'RANCH' ?
                  <img src={ranchIcon} alt="RANCH" className="heal-cost-icon" /> :
                  <img src={rcoinIcon} alt="RCOIN" className="heal-cost-icon" />  
                }
                <span>{healCost.amount} {healCost.token}</span>
              </div>
            </div>
          )}
        </div>
        
        <div className="heal-modal-footer">
          <button 
            className="heal-cancel-button" 
            onClick={onClose}
            disabled={isProcessing}
          >
            Cancel
          </button>
          <button 
            className="heal-confirm-button" 
            onClick={handleConfirm}
            disabled={isProcessing || !healCost}
          >
            {isProcessing ? 'Healing...' : 'Confirm Heal'}
          </button>
        </div>
      </div>
    </div>
  );
}

export default HealModal;
